var map = {
  "./cs.json": [
    "to",
    [
      "rg"
    ]
  ],
  "./en.json": [
    "P9",
    [
      "hl"
    ]
  ],
  "./pl.json": [
    "Bn1",
    [
      "3d"
    ]
  ],
  "./ru.json": [
    "cbB",
    [
      "e"
    ]
  ],
  "./tr.json": [
    "heQ",
    [
      "jdk"
    ]
  ],
  "./ja.json": [
    "O6E",
    [
      "w8c"
    ]
  ],
  "./zh.json": [
    "dDU",
    [
      "jp"
    ]
  ],
  "./pt-br.json": [
    "PZH",
    [
      "1jg"
    ]
  ],
  "./de.json": [
    "he",
    [
      "3r"
    ]
  ],
  "./es.json": [
    "rEC",
    [
      "x61"
    ]
  ],
  "./fr.json": [
    "ol8",
    [
      "iu"
    ]
  ],
  "./it.json": [
    "Y5",
    [
      "e0"
    ]
  ],
  "./ko.json": [
    "wh",
    [
      "ye"
    ]
  ],
  "./pt.json": [
    "Ub",
    [
      "yo"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "uw";
module.exports = __rspack_async_context;
